module.exports = __webpack_public_path__ + "static/media/logo166.0b69e9f8.png";